// FontWeights -> https://drafts.csswg.org/css-fonts/#font-weight-numeric-values
var FontWeights = /*#__PURE__*/function (FontWeights) {
  FontWeights[FontWeights["Thin"] = 100] = "Thin";
  FontWeights[FontWeights["ExtraLight"] = 200] = "ExtraLight";
  FontWeights[FontWeights["Light"] = 300] = "Light";
  FontWeights["Regular"] = "normal";
  FontWeights[FontWeights["Medium"] = 500] = "Medium";
  FontWeights[FontWeights["SemiBold"] = 600] = "SemiBold";
  FontWeights["Bold"] = "bold";
  FontWeights[FontWeights["ExtraBold"] = 800] = "ExtraBold";
  FontWeights[FontWeights["Black"] = 900] = "Black";
  FontWeights[FontWeights["Heavy"] = 1000] = "Heavy";
  return FontWeights;
}(FontWeights || {});
var FontStyles = /*#__PURE__*/function (FontStyles) {
  FontStyles["Normal"] = "normal";
  FontStyles["Italic"] = "italic";
  FontStyles["Oblique"] = "oblique";
  return FontStyles;
}(FontStyles || {});
var FontSizes = /*#__PURE__*/function (FontSizes) {
  FontSizes[FontSizes["Size_1"] = 6] = "Size_1";
  FontSizes[FontSizes["Size_2"] = 8] = "Size_2";
  FontSizes[FontSizes["Size_3"] = 10] = "Size_3";
  FontSizes[FontSizes["Size_4"] = 12] = "Size_4";
  FontSizes[FontSizes["Size_5"] = 14] = "Size_5";
  FontSizes[FontSizes["Size_6"] = 16] = "Size_6";
  FontSizes[FontSizes["Size_7"] = 18] = "Size_7";
  FontSizes[FontSizes["Size_8"] = 20] = "Size_8";
  FontSizes[FontSizes["Size_9"] = 22] = "Size_9";
  FontSizes[FontSizes["Size_10"] = 24] = "Size_10";
  FontSizes[FontSizes["Size_11"] = 26] = "Size_11";
  FontSizes[FontSizes["Size_12"] = 28] = "Size_12";
  FontSizes[FontSizes["Size_13"] = 30] = "Size_13";
  FontSizes[FontSizes["Size_14"] = 32] = "Size_14";
  FontSizes[FontSizes["Size_15"] = 34] = "Size_15";
  FontSizes[FontSizes["Size_16"] = 36] = "Size_16";
  FontSizes[FontSizes["Size_17"] = 38] = "Size_17";
  FontSizes[FontSizes["Size_18"] = 40] = "Size_18";
  FontSizes[FontSizes["Size_19"] = 42] = "Size_19";
  FontSizes[FontSizes["Size_20"] = 44] = "Size_20";
  FontSizes[FontSizes["Size_21"] = 44] = "Size_21";
  FontSizes[FontSizes["Size_22"] = 46] = "Size_22";
  FontSizes[FontSizes["Size_23"] = 48] = "Size_23";
  FontSizes[FontSizes["Size_24"] = 50] = "Size_24";
  FontSizes[FontSizes["Size_25"] = 52] = "Size_25";
  FontSizes[FontSizes["Size_26"] = 54] = "Size_26";
  FontSizes[FontSizes["Size_27"] = 56] = "Size_27";
  FontSizes[FontSizes["Size_28"] = 58] = "Size_28";
  FontSizes[FontSizes["Size_29"] = 60] = "Size_29";
  FontSizes[FontSizes["Size_30"] = 62] = "Size_30";
  FontSizes[FontSizes["Size_31"] = 64] = "Size_31";
  FontSizes[FontSizes["Size_32"] = 66] = "Size_32";
  FontSizes[FontSizes["Size_33"] = 68] = "Size_33";
  FontSizes[FontSizes["Size_34"] = 70] = "Size_34";
  return FontSizes;
}(FontSizes || {});
var FontFormats = /*#__PURE__*/function (FontFormats) {
  FontFormats["WOFF"] = "woff";
  FontFormats["WOFF2"] = "woff2";
  FontFormats["EOT"] = "embedded-opentype";
  FontFormats["TTF"] = "truetype";
  return FontFormats;
}(FontFormats || {});
var fontFamilyName = 'Picsart-Fonts';
var GilroyFonts = [{
  fontFamily: fontFamilyName,
  fontStyle: FontStyles.Normal,
  fontWeight: FontWeights.Thin,
  fallbacks: [{
    src: 'local("Gilroy-Thin")'
  }, {
    src: "url(\"https://cdn140.picsart.com/18776079285769445061.woff\") format('".concat(FontFormats.WOFF, "')")
  }, {
    src: "url(\"https://cdn140.picsart.com/59109029096910982910.woff2\") format('".concat(FontFormats.WOFF2, "')")
  }],
  fontDisplay: 'swap',
  unicodeRange: 'U+0020—007F'
}, {
  fontFamily: fontFamilyName,
  fontStyle: FontStyles.Italic,
  fontWeight: FontWeights.Thin,
  fallbacks: [{
    src: 'local("Gilroy-ThinItalic")'
  }, {
    src: "url(\"https://cdn140.picsart.com/97642694812754574954.woff\") format('".concat(FontFormats.WOFF, "')")
  }, {
    src: "url(\"https://cdn140.picsart.com/84952271197502247721.woff2\") format('".concat(FontFormats.WOFF2, "')")
  }],
  fontDisplay: 'swap',
  unicodeRange: 'U+0020—007F'
}, {
  fontFamily: fontFamilyName,
  fontStyle: FontStyles.Normal,
  fontWeight: FontWeights.ExtraLight,
  fallbacks: [{
    src: 'local("Gilroy-UltraLight")'
  }, {
    src: "url(\"https://cdn140.picsart.com/86547754273719331649.woff\") format('".concat(FontFormats.WOFF, "')")
  }, {
    src: "url(\"https://cdn140.picsart.com/48557371824704947163.woff2\") format('".concat(FontFormats.WOFF2, "')")
  }],
  fontDisplay: 'swap',
  unicodeRange: 'U+0020—007F'
}, {
  fontFamily: fontFamilyName,
  fontStyle: FontStyles.Italic,
  fontWeight: FontWeights.ExtraLight,
  fallbacks: [{
    src: 'local("Gilroy-UltraLightItalic")'
  }, {
    src: "url(\"https://cdn140.picsart.com/65119582298554976418.woff\") format('".concat(FontFormats.WOFF, "')")
  }, {
    src: "url(\"https://cdn140.picsart.com/87919041002689704732.woff2\") format('".concat(FontFormats.WOFF2, "')")
  }],
  fontDisplay: 'swap',
  unicodeRange: 'U+0020—007F'
}, {
  fontFamily: fontFamilyName,
  fontStyle: FontStyles.Normal,
  fontWeight: FontWeights.Light,
  fallbacks: [{
    src: 'local("Gilroy-Light")'
  }, {
    src: "url(\"https://cdn140.picsart.com/32308528797126474379.woff\") format('".concat(FontFormats.WOFF, "')")
  }, {
    src: "url(\"https://cdn140.picsart.com/96092570785581383501.woff2\") format('".concat(FontFormats.WOFF2, "')")
  }],
  fontDisplay: 'swap',
  unicodeRange: 'U+0020—007F'
}, {
  fontFamily: fontFamilyName,
  fontStyle: FontStyles.Italic,
  fontWeight: FontWeights.Light,
  fallbacks: [{
    src: 'local("Gilroy-LightItalic")'
  }, {
    src: "url(\"https://cdn140.picsart.com/84461237855535088382.woff\") format('".concat(FontFormats.WOFF, "')")
  }, {
    src: "url(\"https://cdn140.picsart.com/00208298925357348368.woff2\") format('".concat(FontFormats.WOFF2, "')")
  }],
  fontDisplay: 'swap',
  unicodeRange: 'U+0020—007F'
}, {
  fontFamily: fontFamilyName,
  fontStyle: FontStyles.Normal,
  fontWeight: FontWeights.Regular,
  fallbacks: [{
    src: 'local("Gilroy-Regular")'
  }, {
    src: "url(\"https://cdn140.picsart.com/40435347500710779181.woff\") format('".concat(FontFormats.WOFF, "')")
  }, {
    src: "url(\"https://cdn140.picsart.com/91955639422492369300.woff2\") format('".concat(FontFormats.WOFF2, "')")
  }],
  fontDisplay: 'swap',
  unicodeRange: 'U+0020—007F'
}, {
  fontFamily: fontFamilyName,
  fontStyle: FontStyles.Italic,
  fontWeight: FontWeights.Regular,
  fallbacks: [{
    src: 'local("Gilroy-RegularItalic")'
  }, {
    src: "url(\"https://cdn140.picsart.com/27161838422063216785.woff\") format('".concat(FontFormats.WOFF, "')")
  }, {
    src: "url(\"https://cdn140.picsart.com/43007744222619840386.woff2\") format('".concat(FontFormats.WOFF2, "')")
  }],
  fontDisplay: 'swap',
  unicodeRange: 'U+0020—007F'
}, {
  fontFamily: fontFamilyName,
  fontStyle: FontStyles.Normal,
  fontWeight: FontWeights.Medium,
  fallbacks: [{
    src: 'local("Gilroy-Medium")'
  }, {
    src: "url(\"https://cdn140.picsart.com/52738328758286414073.woff\") format('".concat(FontFormats.WOFF, "')")
  }, {
    src: "url(\"https://cdn140.picsart.com/81787647156170044613.woff2\") format('".concat(FontFormats.WOFF2, "')")
  }],
  fontDisplay: 'swap',
  unicodeRange: 'U+0020—007F'
}, {
  fontFamily: fontFamilyName,
  fontStyle: FontStyles.Italic,
  fontWeight: FontWeights.Medium,
  fallbacks: [{
    src: 'local("Gilroy-MediumItalic")'
  }, {
    src: "url(\"https://cdn140.picsart.com/46735353804242487111.woff\") format('".concat(FontFormats.WOFF, "')")
  }, {
    src: "url(\"https://cdn140.picsart.com/67193124233116808580.woff2\") format('".concat(FontFormats.WOFF2, "')")
  }],
  fontDisplay: 'swap',
  unicodeRange: 'U+0020—007F'
}, {
  fontFamily: fontFamilyName,
  fontStyle: FontStyles.Normal,
  fontWeight: FontWeights.SemiBold,
  fallbacks: [{
    src: 'local("Gilroy-SemiBold")'
  }, {
    src: "url(\"https://cdn140.picsart.com/71881734739985791386.woff\") format('".concat(FontFormats.WOFF, "')")
  }, {
    src: "url(\"https://cdn140.picsart.com/27171823550895557384.woff2\") format('".concat(FontFormats.WOFF2, "')")
  }],
  fontDisplay: 'swap',
  unicodeRange: 'U+0020—007F'
}, {
  fontFamily: fontFamilyName,
  fontStyle: FontStyles.Italic,
  fontWeight: FontWeights.SemiBold,
  fallbacks: [{
    src: 'local("Gilroy-SemiBoldItalic")'
  }, {
    src: "url(\"https://cdn140.picsart.com/18003910673450032764.woff\") format('".concat(FontFormats.WOFF, "')")
  }, {
    src: "url(\"https://cdn140.picsart.com/93697808526997334568.woff2\") format('".concat(FontFormats.WOFF2, "')")
  }],
  fontDisplay: 'swap',
  unicodeRange: 'U+0020—007F'
}, {
  fontFamily: fontFamilyName,
  fontStyle: FontStyles.Normal,
  fontWeight: FontWeights.Bold,
  fallbacks: [{
    src: 'local("Gilroy-Bold")'
  }, {
    src: "url(\"https://cdn140.picsart.com/27605369421922784948.woff\") format('".concat(FontFormats.WOFF, "')")
  }, {
    src: "url(\"https://cdn140.picsart.com/74830162467669988857.woff2\") format('".concat(FontFormats.WOFF2, "')")
  }],
  fontDisplay: 'swap',
  unicodeRange: 'U+0020—007F'
}, {
  fontFamily: fontFamilyName,
  fontStyle: FontStyles.Italic,
  fontWeight: FontWeights.Bold,
  fallbacks: [{
    src: 'local("Gilroy-BoldItalic")'
  }, {
    src: "url(\"https://cdn140.picsart.com/82292024068184483119.woff\") format('".concat(FontFormats.WOFF, "')")
  }, {
    src: "url(\"https://cdn140.picsart.com/20596136228999679836.woff2\") format('".concat(FontFormats.WOFF2, "')")
  }],
  fontDisplay: 'swap',
  unicodeRange: 'U+0020—007F'
}, {
  fontFamily: fontFamilyName,
  fontStyle: FontStyles.Normal,
  fontWeight: FontWeights.ExtraBold,
  fallbacks: [{
    src: 'local("Gilroy-ExtraBold")'
  }, {
    src: "url(\"https://cdn140.picsart.com/66235700952412613224.woff\") format('".concat(FontFormats.WOFF, "')")
  }, {
    src: "url(\"https://cdn140.picsart.com/95606322244042290110.woff2\") format('".concat(FontFormats.WOFF2, "')")
  }],
  fontDisplay: 'swap',
  unicodeRange: 'U+0020—007F'
}, {
  fontFamily: fontFamilyName,
  fontStyle: FontStyles.Italic,
  fontWeight: FontWeights.ExtraBold,
  fallbacks: [{
    src: 'local("Gilroy-ExtraBoldItalic")'
  }, {
    src: "url(\"https://cdn140.picsart.com/02310594553807338731.woff\") format('".concat(FontFormats.WOFF, "')")
  }, {
    src: "url(\"https://cdn140.picsart.com/13104746749564099653.woff2\") format('".concat(FontFormats.WOFF2, "')")
  }],
  fontDisplay: 'swap',
  unicodeRange: 'U+0020—007F'
}, {
  fontFamily: fontFamilyName,
  fontStyle: FontStyles.Normal,
  fontWeight: FontWeights.Black,
  fallbacks: [{
    src: 'local("Gilroy-Black")'
  }, {
    src: "url(\"https://cdn140.picsart.com/35138646371702421068.woff\") format('".concat(FontFormats.WOFF, "')")
  }, {
    src: "url(\"https://cdn140.picsart.com/57749111064467097015.woff2\") format('".concat(FontFormats.WOFF2, "')")
  }],
  fontDisplay: 'swap',
  unicodeRange: 'U+0020—007F'
}, {
  fontFamily: fontFamilyName,
  fontStyle: FontStyles.Italic,
  fontWeight: FontWeights.Black,
  fallbacks: [{
    src: 'local("Gilroy-BlackItalic")'
  }, {
    src: "url(\"https://cdn140.picsart.com/69525859622402900693.woff\") format('".concat(FontFormats.WOFF, "')")
  }, {
    src: "url(\"https://cdn140.picsart.com/82214239100219414003.woff2\") format('".concat(FontFormats.WOFF2, "')")
  }],
  fontDisplay: 'swap',
  unicodeRange: 'U+0020—007F'
}, {
  fontFamily: fontFamilyName,
  fontStyle: FontStyles.Normal,
  fontWeight: FontWeights.Heavy,
  fallbacks: [{
    src: 'local("Gilroy-Heavy")'
  }, {
    src: "url(\"https://cdn140.picsart.com/47358182958732276598.woff\") format('".concat(FontFormats.WOFF, "')")
  }, {
    src: "url(\"https://cdn140.picsart.com/95826343474530510576.woff2\") format('".concat(FontFormats.WOFF2, "')")
  }],
  fontDisplay: 'swap',
  unicodeRange: 'U+0020—007F'
}, {
  fontFamily: fontFamilyName,
  fontStyle: FontStyles.Italic,
  fontWeight: FontWeights.Heavy,
  fallbacks: [{
    src: 'local("Gilroy-HeavyItalic")'
  }, {
    src: "url(\"https://cdn140.picsart.com/55420431258224561886.woff\") format('".concat(FontFormats.WOFF, "')")
  }, {
    src: "url(\"https://cdn140.picsart.com/42997746703780448724.woff2\") format('".concat(FontFormats.WOFF2, "')")
  }],
  fontDisplay: 'swap',
  unicodeRange: 'U+0020—007F'
}];
function withFontFamily(params) {
  var systemFonts = "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen-Sans, Ubuntu, Cantarell, Helvetica Neue, Helvetica, Arabic, sans-serif";
  var fontFamily = params !== null && params !== undefined && params.length ? "".concat(fontFamilyName, ", ").concat(systemFonts) : systemFonts;
  return {
    '@global': {
      html: {
        fontFamily: fontFamily
      },
      '@font-face': params === null || params === undefined ? undefined : params.flat()
    }
  };
}

// GiloriFonts -> GilroyFonts

export { FontFormats, FontSizes, FontStyles, FontWeights, GilroyFonts, withFontFamily };
//# sourceMappingURL=index.js.map
